export const CALENDLY_URL = "https://calendly.com/caleb-holderhospitality/30min";
export const LINKEDIN_URL = "https://linkedin.com/in/crholder";
export const JAKE_LINKEDIN_URL = "https://www.linkedin.com/in/jacoblair/";
export const EMAIL = "caleb@holderhospitality.consulting";
export const LOCATION = "Kansas City, MO";
export const COMPANY = "Holder Hospitality Consulting";
export const TAGLINE = "We Build What's Missing";
